
const ord_arr_by_spec = (array, order) => {

	const orderMap = new Map(order.map((item, index) => [item, index]));

	return array.sort((a, b) => (orderMap.get(a) ?? Infinity) - (orderMap.get(b) ?? Infinity));

}

export default ord_arr_by_spec